import { createContext, useContext, useState, useEffect } from "react";
import SampleProducts from "./SampleProducts";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  // 🟢 Load cart from localStorage when app starts
  useEffect(() => {
    try {
      const storedCart = localStorage.getItem("cartItems");
      if (storedCart) setCart(JSON.parse(storedCart));
    } catch (error) {
      console.error("Error loading cart from localStorage:", error);
    }
  }, []);

  // 🟢 Sync cart with localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem("cartItems", JSON.stringify(cart));
    } catch (error) {
      console.error("Error saving cart to localStorage:", error);
    }
  }, [cart]);

  // ➕ Add item to cart
  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prev, { ...product, quantity: 1 }];
      }
    });
  };

  // ➖ Remove item completely
  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  // 🔄 Clear all items (used after successful payment)
  const clearCart = () => {
    setCart([]); // clear React state
    localStorage.removeItem("cartItems"); // clear localStorage
  };

  // Replace cart in one shot (used by Buy Again/order restore flows)
  const setCartItems = (items) => {
    setCart(Array.isArray(items) ? items : []);
  };

  // 🔼 Increase quantity
  const increaseQuantity = (id) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  // 🔽 Decrease quantity
  const decreaseQuantity = (id) => {
    setCart((prev) =>
      prev
        .map((item) =>
          item.id === id ? { ...item, quantity: item.quantity - 1 } : item
        )
        .filter((item) => item.quantity > 0)
    );
  };

  // 💰 Format prices nicely
  const formatPrice = (price) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(price);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        clearCart,
        setCartItems,
        increaseQuantity,
        decreaseQuantity,
        formatPrice,
        sampleCards: SampleProducts,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export { CartContext };


